import { useMatches, useParams, useNavigate } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { effect, useSignal, useSignalEffect } from "@preact/signals-react"

import logo from '../assets/shift4.png'

import UserBox from './UserBox'

export default function Header({ config, userManifestSignal, userPermissions, userPermissionsSummary}) {

    const { beId } = useParams()
    const matches = useMatches()
    const navigate = useNavigate()
    const activeKey = useSignal('')

    useSignalEffect(() => {
        let print = false
        // updates the active key with the current route 'handle'. This is just extra data we added to the route so we can identify which link to make active
        const matchWithHandle = matches.find(i => i.handle)
        if(!matchWithHandle) {
            navigate('/') // eventually resolve this to the web root once react is fully migrated
        }
        activeKey.value = matchWithHandle && matchWithHandle.handle ? matchWithHandle.handle : ''

        if (print) {
            console.log('userPerms', userPermissions.value)
        }
    })
    if (userPermissionsSummary) {
        return (
            <Navbar variant='dark' expand="lg" bg='dark' className="justify-content-between px-3 py-1">
                <Container fluid>
                    <Navbar.Brand href="/">
                        <img src={logo} height="40" className="d-inline-block align-top" alt="Shift4 Command Center" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls='basic-navbar-nav' />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav activeKey={activeKey.value} className='me-auto' onSelect={eventKey => activeKey.value = eventKey}>
                            <Nav.Link eventKey="dashboard" href={`/be/${beId}/dashboard`}>Dashboard</Nav.Link>
                            ({userPermissionsSummary.canViewUtgs && <Nav.Link eventKey="utgs" href={`/be/${beId}/utgs`}>UTGs</Nav.Link>})
                            ({userPermissionsSummary.canViewUtgs && <Nav.Link eventKey="templates" href={`/be/${beId}/templates`}>Config Templates</Nav.Link>})
                            ({userPermissionsSummary.canViewTasks && <Nav.Link eventKey="tasks" href={`/be/${beId}/tasks`}>Tasks</Nav.Link>})
                            ({userPermissionsSummary.canViewDevices && <Nav.Link eventKey="devices" href={`/be/${beId}/devices`}>Devices</Nav.Link>})
                            ({userPermissionsSummary.canViewForms && <Nav.Link eventKey="forms" href={`/be/${beId}/forms`}>Forms</Nav.Link>})
                            ({userPermissionsSummary.canViewProfiles && <Nav.Link eventKey="profiles" href={`/be/${beId}/profiles`}>Profiles</Nav.Link>})
                            ({userPermissionsSummary.canViewInstallations && <Nav.Link eventKey="installations" href={`/be/${beId}/installations`}>Installations</Nav.Link>})
                            ({userPermissionsSummary.canViewUsers && <Nav.Link eventKey="users" href={`/be/${beId}/users`}>Users</Nav.Link>})
                        </Nav>
                    </Navbar.Collapse>
                    <UserBox config={config}  userManifestSignal={userManifestSignal}></UserBox>
                </Container>
            </Navbar>
        )
    }
}